import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { partnerService } from '../services/partner.service';
import type { Campaign, PaginatedCommissions } from '../types/partner';

const COMMISSIONS_KEY = 'partner-commissions';

export function usePartnerCommissions(params?: {
  page?: number;
  limit?: number;
  status?: string;
}) {
  return useQuery<PaginatedCommissions>({
    queryKey: [COMMISSIONS_KEY, params],
    queryFn: () => partnerService.getCommissions(params),
    staleTime: 1000 * 60 * 2,
    gcTime: 1000 * 60 * 10,
    retry: 2,
  });
}

export function useCampaigns() {
  return useQuery<Campaign[]>({
    queryKey: ['partner-campaigns'],
    queryFn: () => partnerService.getCampaigns(),
    staleTime: 1000 * 60 * 5,
    gcTime: 1000 * 60 * 15,
    retry: 2,
  });
}

interface GenerateDeepLinkResult {
  deepLink: string;
}

export function useGenerateDeepLink() {
  const queryClient = useQueryClient();

  return useMutation<GenerateDeepLinkResult, Error, 'TELEMEDICINE' | 'HOME_VISIT'>({
    mutationFn: (serviceType) =>
      partnerService.generateDeepLink(serviceType),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['partner-campaigns'] });
    },
  });
}